'use client';

import React, { type FC } from 'react';
import { formatCreditsNumber, formatCreditsShort } from '../utils/formatters';
import { FaCoins } from './icons';

interface CreditsProps {
  amount: number;
  className?: string;
  showIcon?: boolean;
  iconSize?: number;
  iconOnly?: boolean; // Show only icon without amount
  muted?: boolean; // Use muted gray color for icon
  compact?: boolean; // Abbreviate to k/M so big amounts fit tight columns
}

export const Credits: FC<CreditsProps> = ({ amount, className, showIcon = true, iconSize = 12, iconOnly = false, muted = false, compact = false }) => {
  const formatted = compact ? formatCreditsShort(amount) : formatCreditsNumber(amount);

  return (
    <span className={`inline-flex items-center gap-1 ${className || ''}`}>
      {!iconOnly && formatted}
      {showIcon && <FaCoins className={muted ? 'text-gray-400 shrink-0' : 'text-amber-400 shrink-0'} size={iconSize} />}
    </span>
  );
};
